export const ActionTypes = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_USERINFO: "SET_USERINFO",
  SELECTED_PRODUCT: "SELECTED_PRODUCT",
  REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
  LOGINDATARESPONSE: "LOGINDATARESPONSE",
};
